export default __webpack_public_path__ + "static/media/MaskGroup347.c217d7cc.png";